module.exports = __webpack_public_path__ + "img/2.b5269f32.png";